'use client';

import { Box, Typography } from '@wishket/design-system';

import ArticleColumnItem, { ArticleColumnItemProps } from './ArticleColumnItem';

interface ArticleSuggestionsProps {
  title: string;
  items?: ArticleColumnItemProps[];
}

const ArticleSuggestions = ({ title, items }: ArticleSuggestionsProps) => {
  return (
    <section className="box-border flex w-full flex-col gap-6 desktop:gap-8">
      <Typography
        variant="subTitle1"
        className="px-5 font-medium text-w-gray-900 desktop:px-0"
      >
        {title}
      </Typography>
      <Box className="-mt-5 flex gap-5 overflow-x-scroll px-5 pt-5 scrollbar-hide tablet:grid tablet:auto-cols-fr tablet:grid-cols-3 desktop:gap-6 desktop:px-0">
        {items?.map((item) => <ArticleColumnItem key={item.id} {...item} />)}
      </Box>
    </section>
  );
};

export default ArticleSuggestions;
